import axios from 'axios';

export default class ChangeLog {

    getLogs() {
        return axios.get('assets/demo/data/change-logs.json').then(res => res.data.data);
    }
}
